import React from "react";
import ModelDataValueUpdateDetailsBase from "./updateModelDataValueBase";
import { DetailRow, ValueChange } from "./baseDetails";
import { dateWithFormat } from "../../tools";

export default function modelDataValueTimeSerieElemUpdateDetails({ row }) {
    return (
        <ModelDataValueUpdateDetailsBase row={row}>
            <DetailRow label="Date">
                <span className="font-mono">{dateWithFormat(row.elem_date)}</span>
            </DetailRow>
            <ValueChange oldValue={row.old_value} newValue={row.new_value} />
        </ModelDataValueUpdateDetailsBase>
    );
}
